import './UnderlineNav-4344d9b0.css';

var classes = {"MenuItemContent":"prc-UnderlineNav-MenuItemContent-k4WNL","MoreButton":"prc-UnderlineNav-MoreButton-smema"};

export { classes as default };
